import { render, staticRenderFns } from "./IbButtonTab.vue?vue&type=template&id=dedab716&scoped=true"
import script from "./IbButtonTab.vue?vue&type=script&lang=js"
export * from "./IbButtonTab.vue?vue&type=script&lang=js"
import style0 from "./IbButtonTab.vue?vue&type=style&index=0&id=dedab716&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedab716",
  null
  
)

export default component.exports